/**
 * Auto generate quote for website
 */
import {QUOTES} from "../data/metadata/quotes";
import moment from "moment";

export function generateQuote() {
  const index: number = Math.floor(Math.random() * MAX_QUOTES) % QUOTES.length;

  return QUOTES[index];
}

export function getTimeRangeFromString(startTime: string, endTime: string) {
  return getTimeRange(new Date(startTime), new Date(endTime));
}

export function getTimeRange(startTime: Date, endTime: Date): string {
  const totalMonth = (endTime.getFullYear() - startTime.getFullYear()) * 12 + endTime.getMonth() - startTime.getMonth();
  const years = Math.floor(totalMonth / 12);
  const month = totalMonth % 12;
  if (years === 0) {
    return `${month} months`;
  } else if (month === 0) {
    return `${years} years`
  } else {
    return `${years} years ${month} months`;
  }
}

export function formatDate(date: string, format: string = null): string {
  return moment(date).format(format ?? 'YYYY-MM-DD');
}

const MAX_QUOTES = 1000
